import React from "react";
import './style.less';
import { Image, Row, Col } from "antd";

export default class ServiceContent extends React.Component {
    render() {
        return (
            <div className={'service-content'}>
                <div className="block">
                    <h1>贴心技术与售后服务</h1>
                    <p>力动几何为用户的产品全生命周期保驾护航<br></br>无论何时，我们都在！</p>
                    <h4>现场解决用户问题是我们持续的目标 </h4>
                    <Row justify="center" className="block-desc">
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <span>8</span> 小时远程处理
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <span>48</span> 小时现场处理
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}
